import Dashboards from './dashboards';
import People from './people';
import Trade from './trade';
import Finance from './finance';
import Operations from './operations';
import Settings from './settings';
import Super from './super';
import BiggieSquare from './biggie-square';
import UserInfo from './user-info';
import Welfare from './welfare';
import Marketing from './marketing';
import Rank from './rank';
import FruitMachine from './fruit-machine';

const mode = import.meta.env.MODE;

export default [
  // ========== 用户端 ==========
  BiggieSquare,
  UserInfo,
  ...(mode !== 'pro_party' ? [Welfare] : []),

  // ========== 管理后台 ==========
  Dashboards,
  People,
  Trade,
  Finance,
  Operations,
  Marketing,
  FruitMachine,
  Rank,

  // ========== 系统 ==========
  Settings,
  Super,
];
